export const DEFAULT_PAGE_SIZE = 30;
export const DEFAULT_SORT_FIELD = 'statDate';
export const DEFAULT_SORT_ORDER = 'descend';
export const DISPLAY_DATE_FORMAT = 'DD.MM.YYYY';
export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const PAGE_SIZE_OPTIONS = [30, 50, 100];

export const SORT_FIELDS: Record<string, string> = {
    statDate: 'id.statDate',
    taxpayerCode: 'id.taxpayerCode',
    apiCode: 'id.apiCode',
    requestCount: 'requestCount',
    errorCount: 'errorCount',
};